export enum FeatureProduct {
    BaseProduct = 1, // MX features + Credit Score
    FinancialInsights,
    EPayStub, // Retired (Pinwheel contract ended 2026-09-30); kept to preserve enum values
    RewardsProgram,
    CompleteBundle, // FinancialInsights + RewardsProgram
    FreeUpsell,
}